const utils = {
  scrollWithOffset: (el, yOff) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = yOff;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  },
};

export default utils;
